import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

/**
 * Componente que permite extender la barra de elementos que tiene el DataTable.
 *
 * @param {Object} props
 * @return {JSX.Element}
 */
const DataTableToolbar = props => {
  const { classes } = props;
  return (
    <Toolbar>
      <div className={classes.title}>
        <Typography 
          component="h1"
          variant="h6"
          color="inherit"
          noWrap>
          {props.title} 
          <span className={classes.description}>{props.description}</span></Typography>
      </div>
      <div className={classes.spacer} />
      {props.children}
    </Toolbar>
  );
};

DataTableToolbar.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.any,

  /**
   * El título del DataTable.
   */
  title: PropTypes.string.isRequired,

  /**
   * Componente a renderizar como children del Toolbar. Útil para
   * renderizar botones adicionales.
   */
  children: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.bool])
  )
};

const toolbarStyles = theme => ({
  spacer: {
    flex: "100 100 100%"
  },
  title: {
    flex: "0 0 auto"
  },
  description: {
    color: "#e54b4b"
  }
});

export default withStyles(toolbarStyles)(DataTableToolbar);
